import React from 'react';
import PropTypes from 'prop-types';

import { paramPropType } from '../hooks';
import { ListItem } from '../styles';

function ParamsItem({
  value, active, onClick,
}) {
  return (
    <ListItem
      active={active}
      onClick={onClick}
    >
      <span>{value.name}</span>
    </ListItem>
  );
}

ParamsItem.propTypes = {
  value: paramPropType.isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

ParamsItem.defaultProps = {
  active: false,
};

export default ParamsItem;
